<template>
  <v-card
    flat
    class="my-3 mx-1"
    style="cursor: pointer"
    @click="checkOrGoProductDetails(product, $event)"
  >
    <div
      v-lazy-container="{
        error: 'https://konselior.s3.amazonaws.com/media/loading_spinner.gif',
        loading: 'https://konselior.s3.amazonaws.com/media/loading_spinner.gif',
      }"
      class="background-card"
    >
      <v-img
        id="product-image"
        contain
        :src="
          loadImage && getMainImage
            ? getMainImage
            : 'https://konselior.s3.amazonaws.com/media/semImagem.jpg'
        "
        :class="{
          imageResize: $vuetify.breakpoint.mdAndUp,
          'image-style': $vuetify.breakpoint.smAndDown,
        }"
        class="product__image"
        @error="loadImage = false"
      >
        <div
          v-if="hasSAC || isPreSale"
          :class="isPreSale ? 'product__presale-tag' : 'product__sac-tag'"
        >
          {{ isPreSale ? 'Pré-venda' : sacTag }}
        </div>
        <div
          v-if="hasSAC && getStoreSkuPrice('old')"
          class="product__sac-discount"
        >
          {{ productDiscount }}
        </div>
        <div
          v-show="canSelect"
          id="checkbox"
          class="add-product-button ma-2"
        >
          <v-icon
            medium
            :color="productSelectIcon.color"
          >
            {{ productSelectIcon.icon }}
          </v-icon>
        </div>
      </v-img>
    </div>
    <v-layout>
      <v-flex class="product-card-alignment mt-2">
        <h5 class="product__sku">
          Código {{ product.reference }}
        </h5>
        <h5 class="product__sku">
          Cód. int. {{ getHighestPrice.sku_id_erp }}
        </h5>
        <h5 class="product__name mt-1">
          <a
            style="text-decoration: none"
            @click="goToProduct(product)"
          >
            {{ product.descricaoCurta }}
          </a>
        </h5>
        <h5 class="product__price mt-1">
          <span
            v-if="getStoreSkuPrice('old')"
            class="product__price__old"
          >
            {{ getHighestPrice.sku_prices[0].old_price | currency }}
          </span>
          <span :style="{ color: hasSAC ? '#FF5146' : '#0C4439' }">
            {{ getHighestPrice.sku_prices[0].price | currency }}
          </span>
        </h5>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable import/no-unresolved, import/extensions */
import { mapGetters } from 'vuex';
import { sacTags } from '../../utils/enum';

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    canSelect: {
      type: Boolean,
      required: false,
    },
    openZeroStockDialog: {
      type: Function,
      default: () => {},
    },
    isPersonalize: {
      type: Boolean,
      default: false,
    },
    store: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    loadImage: true,
  }),

  computed: {
    ...mapGetters(['getStore', 'getCustomer']),

    productSelectIcon() {
      return {
        icon: this.product.checkbox ? 'mdi-minus-circle' : 'mdi-plus-circle',
        color: this.product.checkbox ? '#FF5146' : '#FFBDE5',
      };
    },

    getHighestPrice() {
      let maxSkuPrice = null;
      let maxPrice = -Infinity;

      this.product.skus.forEach((sku) => {
        const { price } = sku.sku_prices[0];

        if (price && price > maxPrice) {
          maxPrice = price;
          maxSkuPrice = sku;
        }
      });

      return maxSkuPrice;
    },

    productDiscount() {
      const percentage = Math.round(
        (1 - this.getStoreSkuPrice('regular') / this.getStoreSkuPrice('old'))
          * 100,
      );

      return `-${percentage}%`;
    },

    hasSAC() {
      return this.product.skus[0].product_type_id < 4;
    },

    // Real number to be determined by the brand
    isPreSale() {
      return this.product.skus[0].product_type_id === 12;
    },

    sacTag() {
      return sacTags[this.product.skus[0].product_type_id];
    },

    getMainImage() {
      const skuImage = this.product.skus.find((sku) => sku.sku_images.some((image) => image.is_main));
      return skuImage
        ? skuImage.sku_images.find((image) => image.is_main).image
        : '';
    },

    currentStock() {
      return (
        this.product.skus[0].sku_stocks
        && this.store
        && this.product.skus[0].sku_stocks.find(
          (stock) => stock.store_id === this.store.id,
        )
      );
    },
  },

  methods: {
    buildProductQuery(product) {
      const { size, color, voltage } = product;

      const productOptions = {
        size,
        color,
        voltage,
      };

      return productOptions;
    },

    goToProduct(product) {
      const query = {};
      if (this.getCustomer.salesAssistant) query.skuId = product.skus[0].sku_id;

      this.$router.push({
        name: 'detalhamento de produtos',
        params: { id: product.id },
        query,
      });

      this.$store.dispatch('setSelectedProductColor', product.cor);
    },

    checkOrGoProductDetails(product, event) {
      if (event.ctrlKey || event.metaKey || event.shiftKey) return;

      if (!this.canSelect) {
        this.goToProduct(product);
      }

      if (
        this.getCustomer.salesAssistant
        && this.isPersonalize
        && this.currentStock.stock < 1
        && !product.checkbox
      ) {
        this.openZeroStockDialog(product);
        return;
      }

      this.$set(product, 'checkbox', !product.checkbox);
    },

    getStoreSkuPrice(priceType) {
      const { old_price, price } = this.getHighestPrice.sku_prices[0];

      const prices = {
        old: old_price > price ? old_price : null,
        regular: price,
      };

      return prices[priceType];
    },
  },
};
</script>

<style scoped lang="scss">
%sac-information {
  position: absolute;
  top: 0;
  height: 18px;
  margin: 8px;
  padding: 4px 6px;
  background: #ff5146;
  border-radius: 2px;
  font-size: min(1.5vw, 8px);
  line-height: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.add-product-button {
  display: inline-block;
  z-index: 1;
}

.product-card-alignment {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  text-align: start;
}

.product {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-size: 12px;
  &__sku {
    font-weight: 600;
    font-size: 10px;
    line-height: 18px;
    color: rgba(20, 12, 34, 0.5);
  }
  &__name {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    text-transform: uppercase;
    color: #140c22;
  }
  &__price {
    display: flex;
    flex-flow: column wrap;
    font-size: 16px;
    font-weight: 800;
    line-height: 22px;
    &__old {
      font-size: 14px;
      font-weight: 600;
      line-height: 14px;
      text-decoration-line: line-through;
      color: #a5a5a5;
    }
  }
  &__image {
    width: 100%;
    display: flex;
    justify-content: end;
    align-items: end;
  }
  &__sac-tag {
    @extend %sac-information;
    left: 0;
    color: #ffffff;
    background: #FF5146;
  }
  &__presale-tag {
    position: absolute;
    width: 65%;
    height: 1.5rem;
    bottom: 10%;
    left: 50%;
    transform: translateX(-50%);
    background: #FFC56F;
    border-radius: 2px;
    font-weight: 700;
    font-size: 10px;
    line-height: 10px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__sac-discount {
    @extend %sac-information;
    right: 0;
    color: #ffffff;
  }
}

::v-deep .v-responsive__content {
  max-width: fit-content;
}
</style>
